// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  API_URL: "https://demo.api.managerescolar.app/api/v1",
  API_PATH: "https://demo.api.managerescolar.app",
  OAUTH_CLIENTE: "https://demo.api.managerescolar.app",

  //API_URL: "https://cum.api.managerescolar.app/api/v1",
 // API_PATH: "https://cum.api.managerescolar.app",
  //OAUTH_CLIENTE: "https://cum.api.managerescolar.app",

  OAUTH_SERVER: "http://api.oa2.che",
  OAUTH_DISPONIBLE: false,

  CFDI_PATH: "https://facturacion.api.managerescolar.app",
  VERSION_CFDI: "4.0",

  pusher_key: "070cf8de972e2ddec550",
  pusher_cluster: "mt1",
  pusher_channel: "my-channel",
  pusher_event: "my-event",
  MENU: [
    {
      titulo: "Panel institucional",
      key: "SucursalConfiguracionController.show",
      path: "/configuracion",
      icono: "icon-capitol",
      lista: [
        {
          titulo: "Configuración Empresa",
          key: "EmpresaConfiguracionController.show",
          path: "/configuracion/empresa-configuracion/editar/1",
          icono: "icon-capitol "
        },
        {
          titulo: "Configuración Campus",
          key: "SucursalConfiguracionController.show",
          path: "/configuracion/sucursal-configuracion/editar/1",
          icono: "icon-building"
        },
        {
          titulo: "Empresas",
          key: "EmpresaController.index",
          path: "/configuracion/empresa/lista",
          icono: "icon-home"
        },
        {
          titulo: "Campus",
          key: "SucursalController.index",
          path: "/configuracion/sucursal/lista",
          icono: "icon-pin"
        },
        {
          titulo: "Cajas",
          key: "CatalogoCajaController.index",
          path: "/configuracion/catalogo-caja/lista",
          icono: "icon-cashbox"
        },
        {
          titulo: "Niveles educativos",
          key: "NivelEducativoController.index",
          path: "/configuracion/nivel-educativo/lista",
          icono: "icon-levels "
        },
        {
          titulo: "Conectar con movil",
          key: "GenerarQrController.qr",
          path: "/configuracion/empresa/qr/1",
          icono: "icon-visualization"
        },
        {
          titulo: "Dashboard Escolar",
          key: "DashboardEscolarController.index",
          path: "/configuracion/dashboard-escolar/dashboard",
          icono: "icon-analytics2"
        },
      ]
    },
    {
      titulo: "Promoción",
      key: "PreinscripcionController.index",
      path: "/promocion",
      icono: "icon-volume",
      lista: [
        {
          titulo: "Preinscripción",
          key: "PreinscripcionController.index",
          path: "/promocion/preinscripcion/lista",
          icono: "icon-clipboard4"
        }
      ]
    },
    {
      titulo: "Control Escolar",
      key: "AlumnoController.index",
      path: "/control-escolar",
      icono: "icon-folders",
      lista: [
        {
          titulo: "Alumnos ",
          key: "AlumnoController.index",
          path: "",
          icono: "icon-group-12",
          lista: [
            {
              titulo: "Alumnos",
              key: "AlumnoController.index",
              path: "/control-escolar/alumno/lista",
              icono: "icon-election"
            },
            {
              titulo: "Expediente de alumno",
              key: "AlumnoOperacionController.expediente",
              path: "/control-escolar/alumno-operacion/operacion",
              icono: "icon-ballot "
            },
            {
              titulo: "Reporte por alumno",
              key: "AlumnoOperacionController.reporte",
              path: "/control-escolar/alumno-operacion/reporte",
              icono: "icon-candidates-1"
            }
          ]
        },
        {
          titulo: "Grupos ",
          key: "GrupoController.index",
          path: "",
          icono: "icon-group2",
          lista: [
            {
              titulo: "Grupos",
              key: "GrupoController.index",
              path: "/control-escolar/grupo/lista",
              icono: "icon-community "
            },
            {
              titulo: "Avanzar Grupos",
              key: "GrupoController.avanzar",
              path: "/control-escolar/grupo/avanzar",
              icono: "icon-exchange22"
            },
            {
              titulo: "Cambiar de Grupo",
              key: "GrupoController.cambiar",
              path: "/control-escolar/grupo/cambiar",
              icono: "icon-exchange-2"
            },
            {
              titulo: "Matriculas",
              key: "GrupoController.matricular",
              path: "/control-escolar/grupo/matricula",
              icono: "icon-candidate"
            },
            {
              titulo: "Incorporación financiera",
              key: "GrupoController.incorporacion",
              path: "/control-escolar/grupo/incorporacion",
              icono: "icon-money-12"
            }
          ]
        },
        {
          titulo: "Regularización de materias",
          key: "AlumnoController.index",
          path: "",
          icono: "icon-puzzle2",
          lista: [
            {
              titulo: "Revalidación",
              key: "RevalidacionController.index",
              path: "/control-escolar/revalidacion/nuevo",
              icono: "icon-insurance"
            },
            {
              titulo: "Repetición",
              key: "RepeticionController.index",
              path: "/control-escolar/repeticion/nuevo",
              icono: "icon-list4"
            }
          ]
        },
        {
          titulo: "Calificaciones ",
          key: "CalificacionController.index",
          path: "",
          icono: "icon-computer6",
          lista: [
            {
              titulo: "Por alumno",
              key: "CalificacionController.index",
              path: "/control-escolar/calificacion/nuevo",
              icono: "icon-exam"
            },
            {
              titulo: "Por grupo",
              key: "CalificacionGrupoController.index",
              path: "/control-escolar/calificacion-grupo/nuevo",
              icono: "icon-test"
            },
            {
              titulo: "Calificaciones Regularización",
              key: "CalificacionGrupoController.reprobados",
              path: "/control-escolar/calificacion-reprobado/nuevo",
              icono: "icon-files2"
            },
            {
              titulo: "Monitor Reprobados",
              key: "CalificacionGrupoController.monitorReprobados",
              path: "/control-escolar/monitor-reprobados/monitor",
              icono: "icon-close"
            }
          ]
        },
        
        {
          titulo: "SE Estatal ",
          key: "SecretariaEducacionController.index",
          path: "",
          icono: "icon-folder ",
          lista: [
            {
              titulo: "Boletas y Kardex",
              key: "CalificacionController.boleta",
              path: "/control-escolar/boleta-kardex/lista",
              icono: "icon-calendar-9"
            },
            {
              titulo: "Registro de escolaridad",
              key: "SecretariaEducacionController.index",
              path: "/control-escolar/registro-escolaridad/lista",
              icono: "icon-calendar-16"
            }
          ]
        },
        {
          titulo: "SE Federal",
          key: "AnexoOchoController.index",
          path: "",
          icono: "icon-file22",
          lista: [
            {
              titulo: "Registros A8",
              key: "AnexoOchoController.index",
              path: "/control-escolar/anexo-ocho/lista",
              icono: "icon-group3"
            },
            {
              titulo: "Nuevo Registro A8",
              key: "AnexoOchoController.tramite",
              path: "/control-escolar/anexo-ocho/tramite",
              icono: "icon-files2"
            }
          ]
        },/*
        {
          titulo: "Titulación",
          key: "TitulacionController.index",
          path: "",
          icono: "icon-file22",
          lista: [
            {
              titulo: "Tramites de Titulación X",
              key: "TitulacionController.index",
              path: "/control-escolar/titulacion/lista",
              icono: "icon-group3"
            },
            {
              titulo: "Nuevo Trámite de Titulación",
              key: "TitulacionController.tramite",
              path: "/control-escolar/titulacion/tramite",
              icono: "icon-files2"
            }
          ]
        },*/
        /*
        {
          titulo: "Secretaria de Educación Federal",
          key: "SecretariaEducacionController.index",
          path: "",
          icono: "icon-folder ",
          lista: [
            {
              titulo: "Nuevo Reporte Anexo 8",
              key: "SecretariaEducacionFederalController.index",
              path: "/control-escolar/anexo-ocho/lista",
              icono: "icon-calendar-16"
            }
          ]
        },*//*
        {
          titulo: "SE Federal",
          key: "AnexoOchoController.index",
          path: "",
          icono: "icon-folder ",
          lista: [
            {
              titulo: "Generar Anexo 8",
              key: "AnexoOchoController.previoAnexoOcho",
              path: "/control-escolar/anexo-ocho/generar",
              icono: "icon-calendar-9"
            },
            {
              titulo: "Consultar Anexo 8",
              key: "AnexoOchoController.index",
              path: "/control-escolar/anexo-ocho/lista",
              icono: "icon-calendar-16"
            }
          ]
        },*/
      ]
    },
    {
      titulo: "Coordinación académica",
      key: "CoordinacionAcademicaController.index",
      path: "/coordinacion-academica",
      icono: "icon-employee2",
      lista: [
        {
          titulo: "Modalidades",
          key: "ModalidadController.index",
          path: "/coordinacion-academica/modalidad/lista",
          icono: "icon-bookshelf"
        },
        {
          titulo: "Carreras",
          key: "CarreraController.index",
          path: "/coordinacion-academica/carrera/lista",
          icono: "icon-mortarboard"
        },
        {
          titulo: "Adeudo Manual",
          key: "AdeudoManualController.index",
          path: "/coordinacion-academica/adeudo-manual/nuevo",
          icono: "icon-mortarboard"
        },
        {
          titulo: "Planes de estudio",
          key: "PlanEstudioController.index",
          path: "/coordinacion-academica/plan-estudio/lista",
          icono: "icon-books"
        },
        //se cambio
        {
          titulo: "Materias por Carreras y Planes",
          key: "CarreraPlanController.index",
          path: "/coordinacion-academica/carrera-plan/lista",
          icono: "icon-open-book"
        },
        {
          titulo: "Modularización",
          key: "CarreraPlanModuloController.index",
          path:
            "/coordinacion-academica/carrera-plan-modulo/lista",
          icono: "icon-online-shop-1"
        },
        // {
        //   titulo: "Materias",
        //   key: "MateriaController.index",
        //   path: "/coordinacion-academica/materia/lista",
        //   icono: "icon-math-book"
        // },
        {
          titulo: "Costos de Materias",
          key: "MateriaCostoController.index",
          path: "/coordinacion-academica/materia-costo/lista",
          icono: "icon-math-book"
        },
        {
          titulo: "Prácticas",
          key: "PracticaController.index",
          path: "/coordinacion-academica/practica/lista",
          icono: "icon-hand"
        },
        {
          titulo: "Ciclos Académicos",
          key: "PeriodoEscolarController.index",
          path: "",
          icono: "icon-calendar-5",
          lista: [
            {
              titulo: "Períodos escolares",
              key: "PeriodoEscolarController.index",
              path: "/coordinacion-academica/periodo-escolar/lista",
              icono: "icon-calendar"
            },
            {
              titulo: "Ciclos escolares",
              key: "CicloEscolarController.index",
              path: "/coordinacion-academica/ciclo-escolar/lista",
              icono: "icon-hourglass"
            }
          ]
        },
        {
          titulo: "Programación de horarios ",
          key: "HorarioController.index",
          path: "",
          icono: "icon-waiting-room2",
          lista: [
            {
              titulo: "Layout Horario",
              key: "HorarioLayoutController.index",
              path:
                "/coordinacion-academica/horario-layout/lista",
              icono: "icon-time"
            },
            {
              titulo: "Horarios",
              key: "HorarioController.index",
              path: "/coordinacion-academica/horario/lista",
              icono: "icon-clock2"
            },
            {
              titulo: "Horarios Docentes",
              key: "HorarioController.prefesor_horario",
              path:
                "/coordinacion-academica/horario-docente/horario",
              icono: "icon-manager2 "
            },
            {
              titulo: "Horarios Diario",
              key: "HorarioController.horario_diario",
              path:
                "/coordinacion-academica/horario-diario/horario",
              icono: "icon-alarm-clock  "
            }
          ]
        }
      ]
    },
    {
      titulo: "Servicios financieros",
      key: "ServicioFinancieroController.index",
      path: "/servicio-financiero",
      icono: "icon-money4",
      lista: [
        {
          titulo: "Operaciones ",
          key: "CajaOperacionController.index",
          path: "",
          icono: "fa fa-flash",
          lista: [
            {
              titulo: "Inscripciones",
              key: "InscripcionController.index",
              path: "/servicio-financiero/inscripcion/lista",
              icono: "icon-clipboard4"
            },
            {
              titulo: "Pagos",
              key: "PagoController.index",
              path: "/servicio-financiero/pago/nuevo",
              icono: "icon-payment-method"
            },
            {
              titulo: "Pagos Publico",
              key: "PagoPublicoController.index",
              path: "/servicio-financiero/pago-publico/lista",
              icono: "icon-payment-method"
            },
            {
              titulo: "Otros Pagos",
              key: "PagoController.index",
              path: "/servicio-financiero/otro-pago/lista",
              icono: "icon-money3"
            },
            {
              titulo: "Caja",
              key: "CajaOperacionController.index",
              path: "/servicio-financiero/caja-operacion/lista",
              icono: "icon-cashbox"
            }
          ]
        },
        {
          titulo: "Generales",
          key: "ReporteResumenController.index",
          path: "",
          icono: "fa fa-cogs",
          lista: [
            {
              titulo: "Catálogo de Servicios",
              key: "ServicioController.index",
              path: "/servicio-financiero/servicio/lista",
              icono: "icon-money-2"
            },
            {
              titulo: "Planes de pagos",
              key: "PlanPagoController.index",
              path: "/servicio-financiero/plan-pago/lista",
              icono: "icon-blueprint"
            },
            {
              titulo: "Becas",
              key: "BecaController.index",
              path: "/servicio-financiero/beca/lista",
              icono: "icon-donation-4"
            },
            {
              titulo: "Bancos",
              key: "BancoController.index",
              path: "/servicio-financiero/banco/lista",
              icono: "icon-piggy-bank3"
            },
            {
              titulo: "Cuentas Bancarias",
              key: "CuentaBancariaController.index",
              path: "/servicio-financiero/cuenta-bancaria/lista",
              icono: "icon-certificate"
            }
          ]
        },
        {
          titulo: "Facturación",
          key: "FacturaController.index",
          path: "",
          icono: "icon-invoice",
          lista: [
            {
              titulo: "Facturas",
              key: "FacturaController.dashboard",
              path:
                "/servicio-financiero/facturacion/factura/dashboard",
              icono: "icon-maintenance"
            },
            {
              titulo: "Facturas",
              key: "FacturaController.index",
              path:
                "/servicio-financiero/facturacion/factura/lista",
              icono: "icon-list2"
            },
            {
              titulo: "Nueva Factura",
              key: "FacturaController.store",
              path:
                "/servicio-financiero/facturacion/factura/nuevo",
              icono: "icon-invoice"
            }
          ]
        }
        // {
        //   titulo: "Resúmenes",
        //   key: "ReporteResumenController.index",
        //   path: "",
        //   icono: "fa fa-paper-plane-o",
        //   lista: [
        //     {
        //       titulo: "Caja",
        //       key: "ReporteResumenController.caja",
        //       path: "/reportes/resumen/caja",
        //       icono: "fa fa-archive"
        //     },
        //     {
        //       titulo: "Ventas",
        //       key: "ReporteResumenController.venta",
        //       path: "/reportes/resumen/venta",
        //       icono: "fa fa-shopping-cart"
        //     }
        //   ]
        // }
      ]
    },
    {
      titulo: "Productos / servicios",
      key: "ArticuloController.index",
      path: "/inventario",
      icono: "icon-books-2",
      lista: [
        {
          titulo: "Productos / servicios",
          key: "ArticuloController.index",
          path: "/inventario/articulo/lista",
          icono: "icon-id-card2"
        },
        {
          titulo: "Articulos de la sucursal",
          key: "ArticuloSucursalController.index",
          path: "/inventario/articulo/sucursal",
          icono: "icon-business-card"
        },
        {
          titulo: "Buscar precio",
          key: "ArticuloController.index",
          path: "/inventario/articulo/precio",
          icono: "icon-search"
        },
        {
          titulo: "Inicialización de inventarios",
          key: "ArticuloController.inicial",
          path: "/inventario/articulo/inicial",
          icono: "icon-apple"
        }
      ]
    },
    {
      titulo: "Catálogos",
      key: "TipoPersonaController.index",
      path: "/catalogos",
      icono: "icon-folder2",
      lista: [
        {
          titulo: "Lugar",
          key: "PaisController.index",
          path: "",
          icono: "icon-earth-globe",
          lista: [
            {
              titulo: "Pais",
              key: "PaisController.index",
              path: "/catalogos/pais/lista",
              icono: "icon-map2 "
            },
            {
              titulo: "Estado",
              key: "EstadoController.index",
              path: "/catalogos/estado/lista",
              icono: "icon-placeholder"
            },
            {
              titulo: "Municipio",
              key: "MunicipioController.index",
              path: "/catalogos/municipio/lista",
              icono: "icon-ping-pong"
            }
          ]
        },
        {
          titulo: "Tipos",
          key: "TipoPersonaController.index",
          path: "",
          icono: "icon-bookmark",
          lista: [
            {
              titulo: "Tipo medio",
              key: "TipoMedioController.index",
              path: "/catalogos/tipo-medio/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo red social",
              key: "TipoRedSocialController.index",
              path: "/catalogos/tipo-red-social/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo persona",
              key: "TipoPersonaController.index",
              path: "/catalogos/tipo-persona/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo Movimiento",
              key: "TipoMovimientoController.index",
              path: "/catalogos/tipo-movimiento/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo moneda",
              key: "TipoMonedaController.index",
              path: "/catalogos/tipo-moneda/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo método pago",
              key: "TipoMetodoPagoController.index",
              path: "/catalogos/tipo-metodo-pago/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo forma pago",
              key: "TipoFormaPagoController.index",
              path: "/catalogos/tipo-forma-pago/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo flujo efectivo",
              key: "TipoFlujoEfectivoController.index",
              path: "/catalogos/tipo-flujo-efectivo/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Tipo baja",
              key: "TipoBajaController.index",
              path: "/catalogos/tipo-baja/lista",
              icono: "icon-bookmark"
            },
            {
              titulo: "Catalogo incidencia",
              key: "CatalogoIncidenciaController.index",
              path: "/catalogos/catalogo-incidencia/lista",
              icono: "icon-bookmark"
            }
          ]
        },
        {
          titulo: "Unidad de Medida",
          key: "UnidadMedidaController.index",
          path: "/catalogos/unidad-medida/lista",
          icono: "icon-ruler"
        },
        {
          titulo: "Presentación",
          key: "PresentacionController.index",
          path: "/catalogos/presentacion/lista",
          icono: "icon-boxes"
        },
        {
          titulo: "Categoria",
          key: "CategoriaController.index",
          path: "/catalogos/categoria/lista",
          icono: "icon-networking-3"
        },
        {
          titulo: "Impuesto",
          key: "ImpuestoController.index",
          path: "/catalogos/impuesto/lista",
          icono: "icon-pie-chart-12"
        },
        {
          titulo: "Documentos",
          key: "DocumentoController.index",
          path: "/catalogos/documento/lista",
          icono: "icon-files "
        }
      ]
    },
    {
      titulo: "Personal",
      key: "PersonaController.index",
      path: "/personal",
      icono: "icon-account",
      lista: [
        {
          titulo: "Administrativos",
          key: "AdministrativoController.index",
          path: "/personal/administrativo/lista",
          icono: "icon-user-4"
        },
        {
          titulo: "Docentes",
          key: "DocenteController.index",
          path: "/personal/docente/lista",
          icono: "icon-user-12"
        }
      ]
    },
    {
      titulo: "Sistema",
      key: "UsuarioController.index",
      path: "/sistema",
      icono: "icon-laptop-22",
      lista: [
        {
          titulo: "Paquetes de Permisos",
          key: "SisGrupoController.index",
          path: "/sistema/grupo/lista",
          icono: "icon-workflow"
        },
        {
          titulo: "Modulos del Sistema",
          key: "SisModuloController.index",
          path: "/sistema/modulo/lista",
          icono: "icon-connection"
        },
        {
          titulo: "Usuarios",
          key: "SisUsuarioController.index",
          path: "/sistema/usuario/lista",
          icono: "icon-user-6"
        },
        {
          titulo: "Version APP",
          key: "VersionAppController.index",
          path: "/sistema/version-app/lista",
          icono: "icon-smartphone-15"
        }
      ]
    },
    {
      titulo: "Descargar APP",
      key: "VersionAppController.descargar",
      path: "/descargar-app",
      icono: "icon-download",
      lista: []
    },
    {
      titulo: "Reportes",
      key: "ReporteController.index",
      path: "/reportes",
      icono: "icon-pie-chart3",
      lista: [
        {
          titulo: "Gráficos",
          key: "ReporteGraficoController.index",
          path: "",
          icono: "fa fa-bar-chart",
          lista: [
            {
              titulo: "Caja",
              key: "ReporteGraficoController.caja",
              path: "/reportes/grafico/caja",
              icono: "fa fa-archive"
            },
            {
              titulo: "Ventas",
              key: "ReporteGraficoController.venta",
              path: "/reportes/grafico/venta",
              icono: "fa fa-shopping-cart"
            },
            {
              titulo: "Adeudos",
              key: "ReporteGraficoController.adeudos",
              path: "/reportes/adeudos/venta",
              icono: "fa fa-shopping-cart"
            },
            {
              titulo: "Compras",
              key: "ReporteGraficoController.compra",
              path: "/reportes/grafico/compra",
              icono: "fa fa-shopping-basket"
            },
            {
              titulo: "Apartados",
              key: "ReporteGraficoController.apartado",
              path: "/reportes/grafico/apartado",
              icono: "fa fa-suitcase"
            },
            {
              titulo: "Traspasos",
              key: "ReporteGraficoController.traspaso",
              path: "/reportes/grafico/traspaso",
              icono: "fa fa-retweet"
            },
            {
              titulo: "Clientes",
              key: "ReporteGraficoController.cliente",
              path: "/reportes/grafico/cliente",
              icono: "fa fa-user-circle"
            },
            {
              titulo: "Proveedor",
              key: "ReporteGraficoController.proveedor",
              path: "/reportes/grafico/proveedor",
              icono: "fa fa-user-secret"
            },
            {
              titulo: "Vendedor",
              key: "ReporteGraficoController.vendedor",
              path: "/reportes/grafico/vendedor",
              icono: "fa fa-users"
            },
            {
              titulo: "Articulos",
              key: "ReporteGraficoController.articulo",
              path: "/grafico/articulo",
              icono: "fa fa-cube"
            },
            {
              titulo: "Categorias",
              key: "ReporteGraficoController.categoria",
              path: "/reportes/grafico/categoria",
              icono: "fa fa-balance-scale"
            }
          ]
        },
        {
          titulo: "Resumen",
          key: "ReporteResumenController.index",
          path: "",
          icono: "fa fa-th-list",
          lista: [
            {
              titulo: "Caja",
              key: "ReporteResumenController.caja",
              path: "/reportes/resumen/caja",
              icono: "fa fa-archive"
            },
            {
              titulo: "Ventas",
              key: "ReporteResumenController.venta",
              path: "/reportes/resumen/venta",
              icono: "fa fa-shopping-cart"
            },
            {
              titulo: "Adeudos",
              key: "ReporteResumenController.adeudos",
              path: "/reportes/resumen/adeudos",
              icono: "icon-money-12"
            },
            {
              titulo: "Facturación",
              key: "ReporteResumenController.factura",
              path: "/reportes/resumen/factura",
              icono: "fa fa-files-o"
            },
            {
              titulo: "Alumnos",
              key: "ReporteResumenController.baja",
              path: "/reportes/resumen/baja",
              icono: "icon-group-12"
            }
          ]
        },
        {
          titulo: "Detallado",
          key: "ReporteDetalladoController.index",
          path: "",
          icono: "fa fa-list-alt",
          lista: [
            {
              titulo: "Caja",
              key: "ReporteDetalladoController.caja",
              path: "/reportes/detallado/caja",
              icono: "fa fa-archive"
            },
            {
              titulo: "Ventas",
              key: "ReporteDetalladoController.venta",
              path: "/reportes/detallado/venta",
              icono: "fa fa-shopping-cart"
            },
            {
              titulo: "Compras",
              key: "ReporteDetalladoController.compra",
              path: "/reportes/detallado/compra",
              icono: "fa fa-shopping-basket"
            },
            {
              titulo: "Apartados",
              key: "ReporteDetalladoController.apartado",
              path: "/reportes/detallado/apartado",
              icono: "fa fa-suitcase"
            },
            {
              titulo: "Traspasos",
              key: "ReporteDetalladoController.traspaso",
              path: "/reportes/detallado/traspaso",
              icono: "fa fa-retweet"
            }
          ]
        },
        {
          titulo: "Inventario",
          key: "ReporteInventarioController.index",
          path: "",
          icono: "fa fa-cubes",
          lista: [
            {
              titulo: "Escaso",
              key: "ReporteInventarioController.escaso",
              path: "/reportes/inventario/escaso",
              icono: "fa fa-cube"
            },
            {
              titulo: "Sobre inventariado ",
              key: "ReporteInventarioController.inventariado",
              path: "/reportes/inventario/inventariado",
              icono: "fa fa-cubes"
            },
            {
              titulo: "Inventario",
              key: "ReporteInventarioController.inventario",
              path: "/reportes/inventario/inventario",
              icono: "fa fa-barcode"
            },
            {
              titulo: "Resagado",
              key: "ReporteInventarioController.resago",
              path: "/reportes/inventario/resago",
              icono: "fa fa-calendar"
            },
            {
              titulo: "Popular",
              key: "ReporteInventarioController.popular",
              path: "/reportes/inventario/popular",
              icono: "fa fa-line-chart"
            }
          ]
        }
      ]
    },
    {
      titulo: "Eventos",
      key: "EventoController.index",
      path: "/eventos",
      icono: "icon-calendar-13",
      lista: [
        {
          titulo: "Categorias Eventos",
          key: "CategoriaEventoController.index",
          path: "/eventos/categoria-evento/lista",
          icono: "icon-calendar-12"
        },
        {
          titulo: "Eventos",
          key: "EventoController.index",
          path: "/eventos/evento/lista",
          icono: "icon-calendar-11"
        },
        {
          titulo: "Imprimir Constancias",
          key: "EventoController.index",
          path: "/eventos/evento/constancia",
          icono: "icon-certificate"
        },
        {
          titulo: "Confirmación de Registro",
          key: "EventoRegistroController.index",
          path: "/eventos/evento/evento-registro",
          icono: "icon-checked"
        },
      ]
    },
    {
      titulo: "Formularios",
      key: "ConfiguracionFormularioController.index",
      path: "/formulario",
      icono: "icon-contract",
      lista: [
        {
          titulo: "Formularios",
          key: "ConfiguracionFormularioController.index",
          path: "/formulario/configuracion-formulario/lista",
          icono: "icon-contract"
        },
        {
          titulo: "Campos Catalogos",
          key: "FsCampoCatalogoController.index",
          path: "/formulario/fs-campo-catalogo/lista",
          icono: "icon-book"
        },
        {
          titulo: "Formulario preinscripción y alumno",
          key: "NivelEducativoFormularioController.show",
          path: "/formulario/nivel-educativo-formulario/editar/1",
          icono: "icon-contract"
        },
        {
          titulo: "Documentos",
          key: "DocumentoController.index",
          path: "/formulario/documento/lista",
          icono: "icon-files "
        }
      ]
    }
  ]
};
